import { useTranslation } from 'react-i18next';
import { withIcon } from '../../core/components/Icon.tsx';
import { faArrowRightLong, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { useLocalStorage } from '../../core/utils/hooks/useLocalStorage.ts';
import { useAssistanceContext } from '../pages/Assistance/AssistanceContext.tsx';
import { Link } from 'react-router';
import { url } from '../../core/utils/link.ts';

const ArrowRightIcon = withIcon(faArrowRightLong);
const CloseIcon = withIcon(faXmark);

const STORAGE_KEY = 'selfServiceFormBannerDismissed';

const SelfServiceFormBanner = () => {
    const { t } = useTranslation('assistance');
    const { record, documentConfiguration } = useAssistanceContext();
    const [dismissed, setDismissed] = useLocalStorage(STORAGE_KEY, false);

    if (dismissed) return null;

    const channelId = record?.channel?.id;
    const channelConfigPath =
        channelId && documentConfiguration?.CHANNEL_PATH
            ? url(documentConfiguration.CHANNEL_PATH + '/config/form', { channelId })
            : null;

    return (
        <div className="w-full px-7 py-4 text-sm flex justify-between items-center gap-4 text-content-strong bg-surface-brand-weak border-b border-solid border-line-weak">
            <div className="flex-auto">
                <span className="font-medium inline-block mr-2">{t('selfServiceFormBanner.title')}</span>
                <span>{t('selfServiceFormBanner.description')}</span>
                {channelConfigPath && (
                    <Link
                        to={channelConfigPath}
                        target="_blank"
                        className="font-medium text-content-brand-strong hover:underline ml-2"
                    >
                        {t('selfServiceFormBanner.cta')} <ArrowRightIcon className="text-sm ml-1 translate-y-0.25" />
                    </Link>
                )}
            </div>
            <button
                type="button"
                className="text-content-weak hover:text-content-strong flex-none cursor-pointer"
                onClick={() => setDismissed(true)}
            >
                <CloseIcon />
            </button>
        </div>
    );
};

export default SelfServiceFormBanner;
